const messages: Record<string, string> = {
	'approval.description':
		'Check if the bank account number given below is correct. If so, confirm the estimate and the above amount will be transferred to your account.',
	'approval.lacquerCosts': 'Paintwork',
	'button.changeImage': 'Change the photo',
	'button.deleteImage': 'Delete the photo',
	'button.prev': 'Back',
	'button.start': 'Next',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'damageImages.additionalImages': 'Additional photos of the damages',
	'damageImages.description':
		'Add at least {imageCount, number} damage {imageCount, plural, one {photo of each damage} other {photos of each damage. Photos should be taken from different distances (zoom-in/whole element)}}. Important: the damage should be fully visible',
	'damageImages.optionalDamageImages': 'Optionally, add more photos showing the damages.',
	'damageImagesExampleModal.headline': 'Damage photos - an example',
	'dashboardMileage.placeholder': 'for example 150000 km',
	'editPhoto.edit': 'Change',
	'feedback.button.send': 'Send the opinion',
	'feedback.description': 'We hope that you are satisfied with our service.',
	'feedback.rating': 'How do you rate the claim settlement with EasyClaim?',
	'payout.headline.first': 'Bank account number',
	'payout.headline.second': 'Account holder',
	'payout.headline.third': 'Account number',
	'review.paragraph.first':
		'Make sure that all the data is entered, then click " Complete". You will receive a summary of the entered data.',
	'review.stepDescription.additionalDocuments': 'Additional documents',
	'vehicleImages.details.first': 'The front of the vehicle',
	'vehicleImages.details.rearright':
		'Take a photo of the vehicle with the whole rear and right side. The license plate should be readable.',
	'vehicleImages.overviewPhotos': 'Vehicle overview photos',
	'vehicleImagesExampleModal.headline.first': 'Vehicle overview photos – an example',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
